/* Talas reviews: show a random selection of the server-rendered pool on every page load.
 * Runs synchronously right after the grid (parser-blocking on purpose) so the final layout exists before first paint: no CLS.
 * The section only renders entries of the current language (English site: en, /ar: ar), so no language mixing here.
 * Desktop shows 6, phone shows 4.
 * Without JS the CSS shows the first 6 entries. */
(function () {
  'use strict';
  var grid = document.querySelector('[data-trv-grid]');
  if (!grid) return;
  try {
    var items = [].slice.call(grid.children);
    var phone = window.matchMedia('(max-width: 767px)').matches;
    var total = phone ? 4 : 6;
    var shuffle = function (a) {
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    };
    var picked = shuffle(items.slice()).slice(0, total);
    if (!picked.length) return;
    items.forEach(function (n) { n.classList.add('is-off'); });
    picked.forEach(function (n) { n.classList.remove('is-off', 'trv__q--extra'); grid.appendChild(n); });
    // unpicked entries stay in the DOM after the picked ones (still in the HTML for search engines / AI)
    items.forEach(function (n) { if (picked.indexOf(n) < 0) grid.appendChild(n); });
  } catch (e) { /* leave the server-rendered first 6 */ }
  grid.classList.add('is-ready');
})();
